import { manualUpdateActionType } from "../actions/actionTypes";

let initialState = {
  isDropdownLoading: false,
};
const manualUpdateReducer = (state = initialState, action) => {
  switch (action.type) {
    case "@@INIT":
      return initialState;
    case manualUpdateActionType.GET_DROPDOWN_VALUE:
      return { ...state, isDropdownLoading: true };
    case manualUpdateActionType.GET_DROPDOWN_VALUE_SUCCESSED:
      return { ...state, isDropdownLoading: false, ...action.payload };
    case manualUpdateActionType.GET_DROPDOWN_VALUE_FAILED:
      return { ...state, isDropdownLoading: false, error: action.payload };
    default:
      return state;
  }
};
export default manualUpdateReducer;
